<template>
	<div class="d-stepper">
		<div class="d-stepper-header d-flex">
			<div
				class="d-title"
				v-for="step in steps"
				v-bind:key="step.id"
				@click="stepClicked(step.id)"
				:class="{
					stepperTitle: step.id != currentStep,
					selectedStep: step.id == currentStep
				}"
			>
				<div
					v-if="step.status"
					class="status-ball"
					:class="{
						statusUncompleted: step.status == 'uncompleted',
						statusError: step.status == 'error'
					}"
				/>
				{{ step.title }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		steps: { type: Array, default: () => [] },
		currentStep: { type: Number }
	},
	methods: {
		stepClicked: function (id) {
			this.$emit("stepClicked", id);
		}
	}
};
</script>

<style scoped>
.d-title {
	display: flex;
	align-items: center;
	gap: 5px;
}

.status-ball {
	width: 8px;
	height: 8px;
	border-radius: 10px;
}

.statusUncompleted {
	background-color: #00648f;
}

.statusError {
	background-color: #dc3545;
}

.d-stepper .d-stepper-header {
	max-width: 100%;
	margin: 0 auto;
	position: relative;
	cursor: pointer;
	margin-left: 24px !important;
}

.selectedStep {
	margin-right: 32px;
	font-weight: bold;
	color: black;
}

.d-stepper .d-stepper-header::before {
	position: absolute;
	width: 100%;
	height: 1px;
	background: #ddd;
	top: 20px;
	left: 0;
	content: " ";
}
.stepperTitle {
	margin-right: 32px;
	color: #8f8f8f;
}
</style>
